import React, { useState, useEffect, useContext } from "react";
import "./rackExpandable.css";
import { ShelvesExpandable } from "../ShelvesExpandable/ShelvesExpandable";
import HierarchyLines from "../../../../TestLine/HierarchyLines";
import { Checkbox, FormControlLabel, FormGroup, Tooltip } from "@mui/material";
import MultioptionButton from "../../../../components/Buttons/MultioptionButton";
import {
  localStorageGet,
  localStorageRemove,
  localStorageSave,
} from "../../../../services/localStorageService";
import { useSnackBar } from "../../../../hooks/useSnackBar";
import { HTTP_RESPONSE_CODES, LABELS } from "../../../../globals/globals";
import { DialogContext } from "../../../../contexts/DialogContext";
import { DeleteRackComponentModal } from "./deleteRackComponentModal/DeleteRackComponentModal";
import {
  createShelf,
  deleteRack,
  getRack,
  getShelves,
  updateRack,
} from "../../services/locationsConfigurationService";
import { getUserCompanyId } from "../../../../services/authService";
import { environment } from "../../../../environments/environment";
import Input from '../../../../components/Inputs/Input';
import { set } from "react-hook-form";
import { LocationsContext } from "../../contexts/LocationsContext";


const rackDraftPrefix = "configuration/locationConfiguration/draft/racks/";
const shelfDraftPrefix = "configuration/locationConfiguration/draft/shelves/";
const binDraftPrefix = "configuration/locationConfiguration/draft/bins/";

export const RackExpandable = ({
  idx,
  totalLength,
  rackBasicInfo,
  isDraft = false,
  isNewRack = false,
  reload = "",
  site_id,
  locationId,
  informationOfDraft,
  parentListLength,
  fullTotalLenght,
}) => {

  const [viewMode, setViewMode] = useState('closed');
  const [isExpanded, setIsExpanded] = useState(false);

  const [data, setData] = useState(rackBasicInfo);
  const [rackNameValue, setRackNameValue] = useState("");
  const [rackDescriptionValue, setRackDescriptionValue] = useState("");
  const [aisleValue, setAisleValue] = useState("");
  const [hazardousMaterial, setHazardousMaterial] = useState(false);
  const [unserviceable, setUnserviceable] = useState(false);
  const [receivingInspection, setReceivingInspection] = useState(false);
  const [draft, setDraft] = useState(isDraft);
  const [childrenDraft, setChildrenDraft] = useState(false)
  const [newRack, setNewRack] = useState(isNewRack);
  const [rackCompleteData, setRackCompleteData] = useState(null);
  const [rackDataInDraft, setRackDataInDraft] = useState(null);
  const { warningMsg, successMsg } = useSnackBar();
  const [hasNameError, setHasNameError] = useState(false);
  const [hasDescriptionError, setHasDescriptionError] = useState(false);
  const [hasAisleError, setHasAisleError] = useState(false);
  const { openDialog, closeDialog } = useContext(DialogContext);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(environment.ElemensPerPage);

  const [shelves, setShelves] = useState([]);
  const [shelvesInDraft, setShelvesInDraft] = useState([]);
  const [AllShelves, setAllShelves] = useState([]);
  const [mostRecentShelf, setMostRecentShelf] = useState([]);
  const [totalShelves, setTotalShelves] = useState(0)
  const [version, setVersion] = useState(0)
  const { draftStatusChanged, setDraftStatusChanged } = useContext(LocationsContext);


  // functions


  const openDeleteRackDialog = () => {
    openDialog({
      component: DeleteRackComponentModal,
      props: {
        rackName: rackBasicInfo.name,
        rackDescription: rackBasicInfo.description,
        close: closeDialog,
        deleteRack: deleteThisRack,
      },
    });
  };

  const validateFields = () => {
    let isValid = true;

    if (!rackNameValue.trim()) {
      setHasNameError(true);
      isValid = false;
    } else {
      setHasNameError(false);
    }

    // if (!rackDescriptionValue.trim()) {
    //   setHasDescriptionError(true);
    //   isValid = false;
    // } else {
    //   setHasDescriptionError(false);
    // }
    if (!aisleValue.trim()) {
      setHasAisleError(true);
      isValid = false;
    } else {
      setHasAisleError(false);
    }

    if (!isValid) {
      warningMsg("Fields required", "Certain empty fields or negative numbers are not allowed");
    }

    return isValid;
  };

  const saveInDraft = () => {
    localStorageSave(
      rackDraftPrefix,
      { locationId: locationId, siteId: site_id, rackId: rackBasicInfo.id },
      rackDataInDraft
    );
    setDraftStatusChanged(!draftStatusChanged)

  };

  const saveRack = async (typeOfFinish = "") => {
    if (!validateFields()) {
      return;
    }

    if (typeOfFinish === "end") {
      let request = await updateRack(rackDataInDraft);
      if (request.data.responseCode == HTTP_RESPONSE_CODES.UPDATED) {
        localStorageRemove(rackDraftPrefix, { rackId: data.id.toString() });
        setDraftStatusChanged(!draftStatusChanged)

        setDraft(false);
        setNewRack(false);
        setIsExpanded(false);
        setViewMode("closed");
        successMsg(
          "Save Successfully",
          "Rack Data Has Been Saved Successfully"
        );
        setRackCompleteData(request.data.load);

        reload();

      }
    } else {
      let request = await updateRack(rackDataInDraft);
      if (request.data.responseCode == HTTP_RESPONSE_CODES.UPDATED) {
        setDraft(true);
        setNewRack(false);
        successMsg(
          "Save Successfully",
          "Rack Data Has Been Saved Successfully , You can Continue Editing."
        );


        // setRackCompleteData(request.data.load);
        setVersion(request.data.load.version)
        setRackDataInDraft(() => {
          const updatedData = {
            version: request.data.load.version,
            id: request.data.load.id,
            name: rackNameValue,
            description: rackDescriptionValue,
            aisle: aisleValue,
            hazardousMaterial:
              hazardousMaterial == "y"
                ? true
                : hazardousMaterial == true
                  ? true
                  : false,
            serviceable:
              unserviceable == "y"
                ? true
                : unserviceable == true
                  ? true
                  : false,
            siteId: site_id,
            companyId: getUserCompanyId(),
            status: "active",
          };

          return updatedData;
        });
      }
    }
  };

  const getInfoRack = async () => {
    let request = await getRack(rackBasicInfo.id);
    if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
      setRackCompleteData(request.data.load);
    }
  };

  const deleteThisRack = async () => {
    const request = await deleteRack(rackBasicInfo.id);

    if (request.data.responseCode == HTTP_RESPONSE_CODES.DELETED) {
      successMsg("Rack Deleted", "Rack deleted successfully");
      localStorageRemove(rackDraftPrefix, { rackId: rackBasicInfo.id });
      closeDialog();
      if (reload) {
        reload();
      }
    }
  };

  const cancelRackEdition = () => {
    setRackNameValue(rackCompleteData.name || "");
    setRackDescriptionValue(rackCompleteData.description || "");
    localStorageRemove(rackDraftPrefix, { rackId: data.id.toString() });
    setDraftStatusChanged(!draftStatusChanged)

    setIsExpanded(false);
    setViewMode("closed");
    setDraft(false);
    if (reload) {
      reload();
    }
  };

  const multiOptionsBtn = [
    { label: "Save", icon: "icon-save", id: "save" },
    {
      label: "Save and Continue Editing",
      icon: "icon-save",
      id: "save-continue",
    },
    { label: "Cancel", icon: "icon-cross", id: "cancel", type: "danger" },
  ];

  const buttonsCallback = {
    save: () => saveRack("end"),
    "save-continue": () => saveRack("continue"),
    cancel: () => cancelRackEdition(),
  };

  // shelves creation

  const getAllShelves = async () => {
    let shelvesInDraft = localStorageGet(shelfDraftPrefix, {
      rackId: data.id.toString(),
    });
    let body = [
      {
        columnName: "rackId",
        value: rackBasicInfo.id,
      },
      {
        columnName: "accountId",
        value: [parseInt(localStorage.getItem("u_account_id"))],
      },
    ];

    let request = await getShelves(page, pageSize, body);

    if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
      setShelvesInDraft(shelvesInDraft);
      setShelves(request.data.load);
      setTotalShelves(request.data.totalRecords)

      if (request.data.load.length <= 0 && shelvesInDraft.length <= 0) {
        setIsExpanded(false);
        setViewMode("closed");
      }
    }
  };


  const createNewShelf = async () => {
    let request = await createShelf();

    if (request.data.responseCode == HTTP_RESPONSE_CODES.CREATED) {
      // setShelves([...shelves, request.data.load]);
      localStorageSave(
        shelfDraftPrefix,
        { locationId: locationId, siteId: site_id, rackId: data.id.toString(), shelfId: request.data.load.id },
        request.data.load
      );
      setDraftStatusChanged(!draftStatusChanged)

      setMostRecentShelf(request.data.load.id)
      successMsg("Shelf Created", "Shelf created successfully");
      setViewMode("shelves");
      setIsExpanded(true);
      getAllShelves();
    }
  };

  const combineShelves = () => {
    const uniqueShelves =
      shelvesInDraft.length > 0
        ? shelvesInDraft.filter(
          (shelf) => !shelves.some((s) => s.id == shelf.id)
        )
        : [];

    setAllShelves([...shelves, ...uniqueShelves]);

  };

  useEffect(() => combineShelves(), [shelves, shelvesInDraft]);


  useEffect(() => {
    if (informationOfDraft) {

      setRackNameValue(informationOfDraft?.name || "");
      // setRackDescriptionValue(informationOfDraft?.description || "");
      setAisleValue(informationOfDraft?.aisle || "");
      setHazardousMaterial(
        informationOfDraft?.hazardousMaterial === "Y"
          ? true
          : informationOfDraft?.hazardousMaterial === "N"
            ? false
            : informationOfDraft?.hazardousMaterial || false
      );
      setUnserviceable(
        informationOfDraft?.serviceable === "Y"
          ? true
          : informationOfDraft?.serviceable === "N"
            ? false
            : informationOfDraft?.serviceable || false
      );
      setReceivingInspection(informationOfDraft?.receivingInspection || false);
      setVersion(informationOfDraft?.version || 0)
    } else {
      setRackNameValue(rackCompleteData?.name ? rackCompleteData?.name : rackBasicInfo?.name ? rackBasicInfo?.name : "");
      // setRackDescriptionValue(rackCompleteData?.description || "");
      setAisleValue(rackCompleteData?.aisle ? rackCompleteData?.aisle : rackBasicInfo?.aisle ? rackBasicInfo?.aisle : "");
      setHazardousMaterial(
        rackCompleteData?.hazardousMaterial === "Y"
          ? true
          : rackCompleteData?.hazardousMaterial === "N"
            ? false
            : rackCompleteData?.hazardousMaterial || false
      );
      setUnserviceable(
        rackCompleteData?.serviceable === "Y"
          ? true
          : rackCompleteData?.serviceable === "N"
            ? false
            : rackCompleteData?.serviceable || false
      );
      setReceivingInspection(rackCompleteData?.receivingInspection || false);
      setVersion(rackCompleteData?.version || 0)
    }
  }, [informationOfDraft, rackCompleteData]);

  useEffect(() => {
    if (isExpanded && viewMode == "edit" && rackCompleteData) {
      const updatedData = {
        version: version,
        id: parseInt(rackBasicInfo.id),
        name: rackNameValue,
        // description: rackDescriptionValue,
        aisle: aisleValue,
        hazardousMaterial:
          hazardousMaterial == "Y"
            ? true
            : hazardousMaterial == true
              ? true
              : false,
        serviceable:
          unserviceable === "Y"
            ? true
            : unserviceable === "N"
              ? false
              : unserviceable || false,
        receivingInspection: receivingInspection,
        siteId: parseInt(site_id),
        accountId: parseInt(localStorage.getItem("u_account_id")),
        status: "active",
      };
      setRackDataInDraft(() => {
        return updatedData;
      });
    }
  }, [
    rackNameValue,
    // rackDescriptionValue,
    aisleValue,
    hazardousMaterial,
    unserviceable,
    rackCompleteData,
    receivingInspection,
    version
  ]);

  useEffect(() => {
    if (isExpanded && viewMode == "edit") {
      saveInDraft();
    }
  }, [rackDataInDraft]);

  useEffect(() => {
    if (isExpanded) {
      getInfoRack();
    }

    if (isExpanded && viewMode == "shelves") {
      getAllShelves();
    }
  }, [isExpanded]);



  const validateChildDraftStatus = () => {
    let hasShelvesDrafts = localStorageGet(shelfDraftPrefix, {
      rackId: data.id.toString(),
    });

    let hasBinsDraft = localStorageGet(binDraftPrefix, {
      rackId: data.id.toString(),
    });

    const hasAnyChildrenDraft = (
      (hasBinsDraft?.length || 0) > 0 ||
      (hasShelvesDrafts?.length || 0) > 0
    );

    setChildrenDraft(hasAnyChildrenDraft);
  };

  useEffect(() => {
    validateChildDraftStatus()
  }, [draftStatusChanged])
  useEffect(() => {
    validateChildDraftStatus()
    if (newRack == true) {
      setViewMode("edit");
      setIsExpanded(true);
    }

    setMostRecentShelf(null)
    setTotalShelves(rackBasicInfo.shelves)
  }, []);


  const reloadShelves = () => {
    getAllShelves();
  };


  const handleHeaderClick = () => {
    if (viewMode === 'edit') return;

    if (viewMode !== 'closed') {
      setViewMode('closed');
      setIsExpanded(false);
    } else {
      setViewMode('form');
      setIsExpanded(true);
    }
  };

  const handleViewShelves = (e) => {
    e.stopPropagation();

    if (viewMode === 'shelves') {

      setViewMode('closed');
      setIsExpanded(false);
    } else {

      setViewMode('shelves');
      setIsExpanded(true);
    }
  };


  const handleEditClick = (e) => {
    e.stopPropagation();
    setViewMode('edit');
    setIsExpanded(true);
    setDraft(true)
  };

  return (
    <>
      <section
        className="rack-grey-bg"
        style={{
          background: viewMode == "edit" ? "var(--white-100)" : viewMode == "form" ? "var(--white-100)" : "",
          border: viewMode == "edit" ? "1px solid #AFAFAF" : viewMode == "form" ? "1px solid #AFAFAF" : "",
          zIndex: viewMode == "edit" ? 2 : "",
        }}
      >
        <section
          className="racks-expandable-header"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              handleHeaderClick()
            }
          }}
          onClick={handleHeaderClick}
          style={{
            backgroundColor: viewMode === 'form' ? 'transparent' : viewMode === 'shelves' ? '#EFFCFF' : viewMode === 'edit' ? 'transparent' : '',
            border: viewMode === 'form' ? 'none' : viewMode === 'shelves' ? '1px solid #B9D8DF' : viewMode === 'edit' ? 'none' : viewMode == "closed" ? "1px solid #E6E6E6" : 'none',
          }}
        >
          {(newRack || draft || childrenDraft) && (
            <span className="draft-rack-span">{LABELS.DRAFT}</span>
          )}
          <HierarchyLines
            idx={idx}
            totalLength={totalLength}
            initialTop={66}
          ></HierarchyLines>
          <span></span>
          <h4>Rack</h4>
          <p
            style={{
              width: "23.5%",
              minWidth: "5rem",
            }}
          >
            Name <Tooltip title={rackNameValue.toUpperCase()} arrow>
              <span className="ellipsis">{rackNameValue || "--"}</span>
            </Tooltip>
          </p>

          <p
            style={{
              width: "16.65%",
              minWidth: "5rem",
            }}
          >
            Aisle<Tooltip title={aisleValue.toUpperCase()} arrow>
              <span className="ellipsis">{aisleValue || "--"}</span>
            </Tooltip>
          </p>
          <p>
            Total shelves <Tooltip title={"View Shelves"} arrow>
              <button className="total-shelves-span" onClick={handleViewShelves}>{totalShelves || 0}</button>
            </Tooltip>
          </p>
          <p>Condition</p>
          <section className="rack-status-icons">

            <Tooltip title="Hazardous Material" arrow>
              {
                informationOfDraft?.hazardousMaterial ? <span className="icon-coloredwarning">
                  <span className="path1"></span>
                  <span className="path2"></span>
                </span> : rackBasicInfo?.hazardous_material == "Y" ? <span className="icon-coloredwarning">
                  <span className="path1"></span>
                  <span className="path2"></span>
                </span> : hazardousMaterial ? <span className="icon-coloredwarning">
                  <span className="path1"></span>
                  <span className="path2"></span>
                </span> : ""
              }
            </Tooltip>

            <Tooltip title="Unserviceable" arrow>
              {
                informationOfDraft?.serviceable ? <span className="icon-unserviceable">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                </span> : rackBasicInfo.serviceable == "Y" ? <span className="icon-unserviceable">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                </span> : unserviceable ? <span className="icon-unserviceable">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                </span> : ""
              }
            </Tooltip>

            <Tooltip title="Required Inspection" arrow>
              {
                informationOfDraft?.receivingInspection ? <span className="icon-required_inspeccion">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                </span> : rackBasicInfo?.receiving_inspection == "Y" ? <span className="icon-required_inspeccion">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                </span> : receivingInspection ? <span className="icon-required_inspeccion">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                </span> : ""
              }
            </Tooltip>

          </section>
          <div className="actions-section-sitesExp">
            {viewMode !== "edit" && <p>New Shelf</p>}
            {viewMode !== "edit" && (
              <Tooltip title="Add new Shelf" arrow>
                <button onClick={(e) => {
                  e.stopPropagation()
                  createNewShelf()
                }}>
                  <i

                    className="icon-add-aircraft"
                    style={{
                      fontSize: "1rem",
                      color: "var(--grey-200)",
                    }}
                  />
                </button>
              </Tooltip>
            )}
            {
              viewMode !== "edit" && <Tooltip title="View Shelves" arrow>
                <button onClick={handleViewShelves}>
                  <i className="icon-icon_view_childs" style={{
                    fontSize: "1rem",
                    color: "var(--grey-200)",
                  }} />
                </button>
              </Tooltip>
            }

            {viewMode !== 'edit' && (
              <Tooltip title="Edit Rack" arrow>
                <button onClick={handleEditClick}>
                  <i className="icon-edit" style={{
                    fontSize: "1rem",
                    color: "var(--grey-200)",
                  }} />
                </button>
              </Tooltip>
            )}
            <Tooltip title="delete rack">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  openDeleteRackDialog()
                }}
              >
                <i

                  className="icon-delete-new"
                  style={{
                    fontSize: "1rem",
                    color: "var(--grey-200)",
                  }}
                />
              </button>
            </Tooltip>
            {viewMode == "edit" && (
              <MultioptionButton
                buttons={multiOptionsBtn}
                buttonCallbacks={buttonsCallback}
              />
            )}
            {/* <i
              style={{
                transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
              }}
              className="icon-arrow-down"
              onClick={() => {
                setEditionMode(false);
                setIsExpanded(!isOpen);
              }}
            /> */}
          </div>
        </section>
        <section className={`racks-expandable-content ${isExpanded ? "open" : ""}`}>
          {viewMode == "edit" ? (
            <section className="form-edit-rack">
              <div className="inp-cont-formRack">

                <Input
                  label={"Name"}
                  value={rackNameValue}
                  onChange={(e) => {
                    setRackNameValue(e.target.value);
                    setHasNameError(false);
                  }}
                  name={"rackName"}
                  error={hasNameError}
                  disableAutocomplete={true}
                  upperCase={true}

                />
                <Input
                  value={aisleValue}
                  onChange={(e) => {
                    setAisleValue(e.target.value);
                    setHasAisleError(false);
                  }}
                  name={"Aisle"}
                  error={hasAisleError}
                  label={"Aisle"}
                  disableAutocomplete={true}
                  upperCase={true}

                />

              </div>
              <div className="checks-cont-formRack">

                <FormControlLabel
                  sx={{
                    background: "var(--white)",
                    paddingRight: ".5rem",
                    borderRadius: "var(--button-radius)",
                    margin: "0",
                    height: "var(--input-height)"

                  }}
                  control={
                    <Checkbox
                      checked={hazardousMaterial}
                      onChange={(e) => {
                        setHazardousMaterial(e.target.checked);
                      }}
                    />
                  }
                  label={
                    <p
                      style={{
                        color: "var(--black-mid)",
                        fontSize: "calc(var(--p-size) + .1rem)",
                        fontWeight: "500",
                        display: "flex",
                        alignItems: "center",
                        gap: ".5rem",
                      }}
                    >
                      Hazardous Material
                      <span className="icon-coloredwarning">
                        <span className="path1"></span>
                        <span className="path2"></span>
                      </span>
                    </p>
                  }
                />

                <FormControlLabel
                  sx={{
                    background: "var(--white)",
                    paddingRight: ".5rem",
                    borderRadius: "var(--button-radius)",
                    margin: "0",
                    height: "var(--input-height)"


                  }}
                  control={
                    <Checkbox
                      checked={unserviceable}
                      onChange={(e) => {
                        setUnserviceable(e.target.checked);
                      }}
                    />
                  }
                  label={
                    <p
                      style={{
                        color: "var(--black-mid)",
                        fontSize: "calc(var(--p-size) + .1rem)",
                        fontWeight: "500",
                      }}
                    >
                      Unserviceable
                    </p>
                  }
                />
                <FormControlLabel
                  sx={{
                    background: "var(--white)",
                    paddingRight: ".5rem",
                    borderRadius: "var(--button-radius)",
                    margin: "0",
                    height: "var(--input-height)"


                  }}
                  control={
                    <Checkbox
                      checked={receivingInspection}
                      onChange={(e) => {
                        setReceivingInspection(e.target.checked);
                      }}
                    />
                  }
                  label={
                    <p
                      style={{
                        color: "var(--black-mid)",
                        fontSize: "calc(var(--p-size) + .1rem)",
                        fontWeight: "500",
                      }}
                    >
                      Required Inspection
                    </p>
                  }
                />
              </div>
            </section>
          )
            : viewMode == "form" ? (
              <section className="form-edit-rack">
                <div className="inp-cont-formRack">

                  <Input
                    label={"Name"}
                    value={rackNameValue}
                    onChange={(e) => {
                      setRackNameValue(e.target.value);
                      setHasNameError(false);
                    }}
                    name={"rackName"}
                    error={hasNameError}
                    disableAutocomplete={true}
                    upperCase={true}
                    disabled={true}
                  />
                  <Input
                    value={aisleValue}
                    onChange={(e) => {
                      setAisleValue(e.target.value);
                      setHasAisleError(false);
                    }}
                    name={"Aisle"}
                    error={hasAisleError}
                    label={"Aisle"}
                    disableAutocomplete={true}
                    upperCase={true}
                    disabled={true}

                  />

                </div>
                <div className="checks-cont-formRack">

                  <FormControlLabel
                    disabled={true}

                    sx={{
                      background: "var(--white)",
                      paddingRight: ".5rem",
                      borderRadius: "var(--button-radius)",
                      margin: "0",
                      height: "var(--input-height)",

                    }}
                    control={
                      <Checkbox
                        checked={hazardousMaterial}
                        onChange={(e) => {
                          setHazardousMaterial(e.target.checked);
                        }}
                      />
                    }
                    label={
                      <p
                        style={{
                          color: "var(--black-mid)",
                          fontSize: "calc(var(--p-size) + .1rem)",
                          fontWeight: "500",
                          display: "flex",
                          alignItems: "center",
                          gap: ".5rem",
                        }}
                      >
                        Hazardous Material
                        <span className="icon-coloredwarning">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </span>
                      </p>
                    }
                  />

                  <FormControlLabel
                    disabled={true}

                    sx={{
                      background: "var(--white)",
                      paddingRight: ".5rem",
                      borderRadius: "var(--button-radius)",
                      margin: "0",
                      height: "var(--input-height)"


                    }}
                    control={
                      <Checkbox
                        checked={unserviceable}
                        onChange={(e) => {
                          setUnserviceable(e.target.checked);
                        }}
                      />
                    }
                    label={
                      <p
                        style={{
                          color: "var(--black-mid)",
                          fontSize: "calc(var(--p-size) + .1rem)",
                          fontWeight: "500",
                        }}
                      >
                        Unserviceable
                      </p>
                    }
                  />
                  <FormControlLabel
                    disabled={true}

                    sx={{
                      background: "var(--white)",
                      paddingRight: ".5rem",
                      borderRadius: "var(--button-radius)",
                      margin: "0",
                      height: "var(--input-height)"


                    }}
                    control={
                      <Checkbox
                        checked={receivingInspection}
                        onChange={(e) => {
                          setReceivingInspection(e.target.checked);
                        }}
                      />
                    }
                    label={
                      <p
                        style={{
                          color: "var(--black-mid)",
                          fontSize: "calc(var(--p-size) + .1rem)",
                          fontWeight: "500",
                        }}
                      >
                        Required Inspection
                      </p>
                    }
                  />
                </div>
              </section>
            )
              : viewMode == "shelves" ? (
                AllShelves.map((shelf, idx) => {
                  return (
                    <ShelvesExpandable
                      key={shelf.id}
                      Length={shelves.length}
                      rack_id={rackBasicInfo.id}
                      siteId={site_id}
                      locationId={locationId}
                      idx={idx}
                      isDraft={shelvesInDraft.some((s) => s.id == shelf.id)}
                      isNewShelf={mostRecentShelf == shelf.id}
                      reload={reloadShelves}
                      bigParentListLenght={parentListLength}
                      parentLenghts={fullTotalLenght}
                      fullTotalLenght={AllShelves.length}
                      shelfBasicInfo={shelf}
                      informationOfDraft={shelvesInDraft.find((s) => s.id == shelf.id)}
                    />
                  );
                })
              ) : ""
          }
        </section>
      </section>
    </>
  );
};
